import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';

export function configureSentry() {
  Sentry.init({
    dsn: 'https://95898c0fba77430f959fc4700f5f91f5@o393235.ingest.sentry.io/5242003',
    integrations: [new Integrations.BrowserTracing()],
    environment: location.hostname === 'localhost' ? 'development' : 'production',
    tracesSampler: (samplingContext) => {
      if (samplingContext.sampleRate >= 0) {
        // Use manual sample rate
        return samplingContext.sampleRate;
      }
      if (samplingContext.polling) {
        // Use polling sample rate 0.01% (less often since this just keeps going)
        return 0.0001;
      }
      if (samplingContext.mutation) {
        // Mutations are sampled more often, 5% (they're much more rare)
        return 0.05;
      }
      return 0.001; // Default sample rate is 0.1%
      /*
        - We want to have a max of 100K events per month
        - There's an estimated 400 active hours per month (31*5/7*24*0.75)
        - => so we want a max of ~100K/400=250 events per hour... But probably less for wiggle room. Let's say 100...
      */
    },
  });
}
